// extracted by mini-css-extract-plugin
export default {"innerWrapper":"innerBanner_innerWrapper__OtCzU","imgWrapper":"innerBanner_imgWrapper__y1EvM"};